<template lang="pug">
v-app.L1
  v-container
    v-content
      v-layout
        v-flex.L1-flex
          transition(:name="currentStep.transition")
            keep-alive
              component(:is="currentComponent")          
            
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import jsondata from '@/data/lessons/TPV/L1/L1.json';

export default {
  name: 'L1',  
  computed: {    
    ...mapGetters(['currentStep'])
  },
  beforeMount() {
    this.setCurrentLesson(this.data);
    this.initSCORM();
  },
  beforeDestroy() {
    this.suspendScore();
  },
  watch: {
    currentStep: function (step) {
      this.currentComponent = () => import(`@/${step.componentPath}`)
    }
  },
  data() {    
    return {      
      data: jsondata,
      transitionName: 'slide',
      currentComponent: null
    }
  },
  methods: {
    ...mapMutations(['setCurrentLesson']),
    ...mapActions(['initSCORM', 'suspendScore'])    
  }
}
</script>

<style scoped>
@import 'L1.scss';
</style>
